import { useEffect, useLayoutEffect } from "react";

/** useLayoutEffect on the client; useEffect on the server — avoids SSR warnings in _app and pages. */
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
